import { render } from "./ModalRemoveRole.vue?vue&type=template&id=27a4f9ca"
import script from "./ModalRemoveRole.vue?vue&type=script&lang=js"
export * from "./ModalRemoveRole.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__